// extracted by css-extract-rspack-plugin
export default {"hidden":"hidden--ABBM8k5ArRIWYzLV"};